// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".secure-icon[data-v-19626141]{width:50px;height:50px}.border-top[data-v-19626141]{border-top:1px solid #e5e5eb}", ""]);
// Exports
module.exports = exports;
